import React, { createContext, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import { ConfigContext } from 'src/store/ConfigContext'
import { generateApiError } from 'src/utils/helpers'
import {
  SUBSCRIPTION_DEACTIVATING_WITHIN_TRIAL_ERROR,
  SUBSCRIPTION_DEACTIVATING_AFTER_TRIAL_ERROR,
  SUBSCRIPTION_SUSPENDED_ERROR,
  SUBSCRIPTION_INACTIVE_WARRANTY_ERROR
} from 'src/config/constants'
import { SUBSCRIPTION_STATES, OOBE_STATUS } from '../config/constants'

export const HPAllInContext = createContext({
  subscription: null,
  subscriptionError: null
})

const HPAllInProvider = ({ children }) => {
  const { sessionContext } = useContext(ConfigContext)

  const subscription = useMemo(() => {
    return (
      sessionContext?.derivedAttributes?.subscriptionStateSvc?.getSubscriptions
        ?.responsePayload || null
    )
  }, [sessionContext])

  const subscriptionError = useMemo(() => {
    if (!subscription) {
      return generateApiError(SUBSCRIPTION_SUSPENDED_ERROR)
    }

    const { state, controllerData } = subscription
    const oobeStatus = controllerData?.oobeStatus

    if (state === SUBSCRIPTION_STATES.DEACTIVATING) {
      if (oobeStatus === OOBE_STATUS.CANCEL_WITHIN_TRIAL) {
        return generateApiError(SUBSCRIPTION_DEACTIVATING_WITHIN_TRIAL_ERROR)
      }
      if (oobeStatus === OOBE_STATUS.CANCEL_AFTER_TRIAL) {
        return generateApiError(SUBSCRIPTION_DEACTIVATING_AFTER_TRIAL_ERROR)
      }
    }

    if (state === SUBSCRIPTION_STATES.SUSPENDED) {
      return generateApiError(SUBSCRIPTION_SUSPENDED_ERROR)
    }

    if (
      state === SUBSCRIPTION_STATES.INACTIVE &&
      oobeStatus === OOBE_STATUS.WARRANTY
    ) {
      return generateApiError(SUBSCRIPTION_INACTIVE_WARRANTY_ERROR)
    }

    return null
  }, [subscription])

  const state = useMemo(
    () => ({
      subscription,
      subscriptionError
    }),
    [subscription, subscriptionError]
  )

  return (
    <HPAllInContext.Provider value={state}>{children}</HPAllInContext.Provider>
  )
}

HPAllInProvider.propTypes = {
  children: PropTypes.node
}

export default HPAllInProvider
